import { pushEvent } from '../../client/data-layer';

export const trackExpandPriceRowClick = (
  productId: number,
  productName?: string,
  storeId?: number,
  storeName?: string
) => {
  pushEvent('priceListPriceRowExpanded', {
    productId,
    productName,
    storeId,
    storeName,
  });
};

export const trackShopLogoClick = (storeId: number) => {
  pushEvent('offerShopLogoClicked', {
    storeId,
  });
};

export const trackProductPriceClickRevenue = ({
  id,
  price,
}: {
  id: number;
  price: number;
}) => {
  pushEvent('productPriceClickRevenue', { id, price });
};
